export default __webpack_public_path__ + "static/media/ABF_Logo_768.be631ba0.png";